import Rate from "./Rate";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useFetchGraphQL from "../../hooks/useFetchGraphQL";

const RatesList = ({t}) => {
  const navigate = useNavigate();
  const { fetchRates } = useFetchGraphQL();
  const [ratesDB, setRatesDB] = useState([]);
  const ratesData = Object.values(t("pages.rates.options", { returnObjects: true })).map(rate => ({
    id: rate.id,
    dbId: rate.dbId,
    duration: rate.duration,
    price: rate.price,
    description: rate.description,
    detailedDescription: rate.detailedDescription,
    to: rate.to,
    logo: rate.logo,
    showActionContainer: rate.showActionContainer
  }));

    // Load rates
    useEffect(() => {
      const loadRates = async () => {
        try {
          const rates = await fetchRates();
          setRatesDB(rates);
        } catch (error) {
          console.error(error);
        }
      };
      loadRates();
    }, []);

  return (
    <>
        <div className="generic-list">
            {ratesData.map((rate, index) => (
                <Rate 
                  key={index}
                  id={rate.id}
                  logo={rate.logo}
                  title={rate.duration} 
                  description={rate.description}
                  price={getTotalAmountById(ratesDB, rate.dbId) + rate.price}
                  detailedDescription={getDetailedDescription(ratesDB, rate.dbId, rate.detailedDescription)}
                  onClick={() => {navigate(rate.to)}}
                />
            ))}
        </div>
        {/*         
        <div className="generic-separator"/>
        <div className="generic-list-description">
            {ratesData.map((rate, index) => (
            <div id={"description-" + rate.id} key={rate.id}>
                <RateDescription 
                    title={rate.duration} 
                    price={getTotalAmountById(ratesDB, rate.dbId) + rate.price} 
                    description={getDetailedDescription(ratesDB, rate.dbId, rate.detailedDescription)}
                    showBottomBorder={!(index === ratesData.length - 1)}
                    onButtonClick={() => {navigate(rate.to)}}
                    buttonInfo={t("pages.rates.texts.text1", { returnObjects: true })}
                    showActionContainer={rate.showActionContainer}
                />
            </div>
            ))}
        </div>
        */}
    </>
  );
};

export default RatesList;

const getDetailedDescription = (ratesDB, dbId, detailedDescription) => {
  let updatedDetailedDescription = detailedDescription;
  if (dbId === "hday") {
    const hourRate = ratesDB.find(rate => rate.id === "hour");
    const hourRateValue = hourRate ? hourRate.TotalAmount : "-";
    updatedDetailedDescription = detailedDescription.replace('%hourRate%', hourRateValue)
  }
  return updatedDetailedDescription;
}

const getTotalAmountById = (ratesDB, dbId) => {
  const rate = ratesDB.find(rate => rate.id === dbId);
  return rate ? rate.TotalAmount : "-";
};